/* eslint-disable no-case-declarations, no-param-reassign */
import _ from 'lodash';

import * as types from '../action.types';

export const initialState = [];

const OriginalDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SESSION_SUCCESS:
      return action.payload.virtualFile
        ? action.payload.data
        : _.map(action.payload.data, row => _.reduce(row, (result, value, key) => {
          result[`${action.payload.filename}.${key}`] = value;
          return result;
        }, {}));

    case types.RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default OriginalDataReducer;
